export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eingabe:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weiter"])}
}